import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationLeadTodoAppliedRuleApiService } from './organization-lead-todo-applied-rule-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationLeadTodoAppliedRuleApiService extends GeneratedOrganizationLeadTodoAppliedRuleApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
